import { useDayPicker } from 'react-day-picker';

export function HeadRow(props) {
  const { classNames, styles } = useDayPicker();

  return (
    <thead aria-hidden>
      <tr {...props} style={styles?.weekdays} className={classNames.weekdays}>
        {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map((weekday) => (
          <th key={weekday} scope="col" className={classNames.weekday} style={styles?.weekday}>
            {weekday}
          </th>
        ))}
      </tr>
    </thead>
  );
}
